import React, { useRef } from 'react';
import {
    Container,
    Stack,
    Typography,
    TextField,
    Box,
    Divider,
    useTheme,
    useMediaQuery,
    ImageList,
    ImageListItem,
    Button,
    Slide,
    Paper,
    duration
    // makeStyles
} from '@mui/material';
import EclipseLarge from '../../assets/icons/EclipseLarge';
import EclipseMedium from '../../assets/icons/EclipseMedium';
import EclipseSmall from '../../assets/icons/EclipseSmall';
import SmsIconBlue from '../../assets/icons/SmsIconBlue';
import ArrowIcon from '../../assets/icons/ArrowIcon';
import '@fontsource/poppins';
import HeroOval1 from '../../assets/Images/HeroOval1.webp';
import HeroOval2 from '../../assets/Images/HeroOval2.webp';
import HeroOval3 from '../../assets/Images/HeroOval3.webp';
import HeroOval4 from '../../assets/Images/HeroOval4.webp';
import HeroOval5 from '../../assets/Images/HeroOval5.webp';
import HeroOval6 from '../../assets/Images/HeroOval6.webp';
import HeroOval7 from '../../assets/Images/HeroOval7.webp';
import HeroOval8 from '../../assets/Images/HeroOval8.webp';
import heroDots from '../../assets/Images/HeroDots.webp';
// import './Theme/css/cabinet-grotesk.css';

import heroBackground from '../../assets/Images/heroBackground.webp';
import Slider from 'react-slick';
import { useAppDispatch } from '../../Feature/Store/Store';
import { openSignupModalState } from '../../Feature/App/AppSlice';
import BackgroundImage from '../../assets/Images/OurApproachBackgroundTexture.webp';
import SideMenuRightArrow from '../../assets/icons/SideMenuRightArrow';
import ArrowRightIconYellow from '../../assets/icons/ArrowRightIconYellow';
import ArrowRightIcon1 from '../../assets/icons/ArrowRightIcon1';
import ArrowLeftIconBlue from '../../assets/icons/ArrowLeftIconBlue';
import ArrowRightWhiteIconBold from '../../assets/icons/ArrowRightWhiteIconBold';
import { redirect, useNavigate } from 'react-router-dom';
// import { makeStyles } from '@mui/system/style'
type HeroSectionProps = {
    formik: any;
};

const HeroSection = ({ formik }: HeroSectionProps) => {
    const dispatch = useAppDispatch();
    const containerRef = useRef(null);
    const navigate = useNavigate();

    const [checked, setChecked] = React.useState(true);
    const [toggleHero, setToggleHero] = React.useState(false); // toggles hire/get hired

    const heroImages = [HeroOval1, HeroOval2, HeroOval3, HeroOval4];

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const isMedium = useMediaQuery(theme.breakpoints.down('md'));

    // const [email, setEmail] = useState('');
    // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => { // to be used when modals have been created
    //     setEmail(event.target.value);
    // }

    const settings = {
        fade: true,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        nextArrow: <></>,
        prevArrow: <></>
    };

    const imageStyles = {
        zIndex: 1,
        position: 'relative',
        m: 1,
        background: 'none',
        borderRadius: '1000px'
    };

    const handleClick = () => {
        setToggleHero(!toggleHero);
        // console.log(toggleHero);
        // handleCreateAccount();
    };

    const handleCreateAccount = () => {
        if (toggleHero) {
            navigate('/create-account/company');
        } else {
            navigate('/create-account/professional');
        }
    };

    return (
        <Container
            maxWidth={false}
            disableGutters
            sx={{
                position: 'relative',
                // background: toggleHero
                //     ? 'primary.yellow'
                //     : 'primaryBlue.main',
                // backgroundImage: `url(${BackgroundImage})`,
                // backgroundRepeat: 'no-repeat',
                // backgroundPosition: 'center center',
                // backgroundSize: 'cover',
                // backgroundBlendMode: 'overlay',
                mx: '0 auto'
                // height: isMobile ? '142%' : '100%',
            }}
        >
            <Stack
                sx={{
                    // zIndex: 2,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: toggleHero
                        ? 'primary.yellow'
                        : 'primaryBlue.main',
                    backgroundImage: `url(${BackgroundImage})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                    backgroundBlendMode: 'overlay'
                    // height: isMobile ? '142%' : '100%',
                    // mb: isMobile ? '150px' : undefined
                }}
            ></Stack>
            <Container
                maxWidth={false}
                disableGutters
                sx={{
                    height: '130%',
                    display: 'flex',
                    pt: isMobile ? '134px' : '244px',
                    flexDirection: 'row',
                    justifyContent: isMobile || isMedium ? 'center' : 'center',
                    flexWrap: isMobile || isMedium ? 'wrap' : 'nowrap',
                    mb: isMobile ? '47px' : undefined
                }}
            >
                {/* Left side Animation */}
                {!toggleHero ? (
                    <Stack
                        zIndex={3}
                        position="relative"
                        sx={{
                            width: isMobile ? '100%' : '55%',
                            mx: isMobile ? '16px' : '60px',
                            display: 'flex',
                            flexDirection:
                                isMobile || isMedium ? 'column' : 'row',
                            // flexWrap: isMobile ? 'wrap' : 'nowrap',
                            alignItems:
                                isMobile || isMedium ? 'center' : undefined,
                            justifyContent: 'center',
                            gap: '22px'
                            // mb: isMobile ? '0' : '150px'
                        }}
                    >
                        <Stack>
                            <Button
                                onClick={handleClick}
                                sx={{
                                    display: 'flex',
                                    p: '4px',
                                    textTransform: 'none',
                                    fontSize: '20px',
                                    // width: 'fit-content',
                                    width: isMobile ? 'fit-content' : '372px',
                                    borderRadius: '100px',
                                    border: '4px solid #FFC24C',
                                    mb: '32px',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    alignContent: 'center'
                                }}
                                variant="text"
                            >
                                <Typography
                                    sx={{
                                        fontSize: isMobile ? '14px' : '20px',
                                        fontFamily: 'Outfit',
                                        fontWeight: '700',
                                        lineHeight: '28px',
                                        // wordWrap: 'break-word',
                                        backgroundColor: 'primary.yellow',
                                        color: theme.palette.primary.dark,
                                        borderRadius: '100px',
                                        padding: '4px 8px',
                                        textTransform: 'uppercase'
                                    }}
                                >
                                    Hire an employee
                                </Typography>
                                <Typography
                                    sx={{
                                        display: 'flex',
                                        fontSize: isMobile ? '14px' : '20px',
                                        fontFamily: 'Outfit',
                                        fontWeight: '700',
                                        lineHeight: '28px',
                                        wordWrap: 'break-word',
                                        color: 'primary.yellow',
                                        borderRadius: '100px',
                                        padding: '4px 8px',
                                        textTransform: 'uppercase',
                                        '& svg': {
                                            marginLeft: '8px'
                                        },
                                        alignItems: 'center'
                                    }}
                                >
                                    Get Hired <ArrowRightIconYellow />
                                </Typography>
                            </Button>
                            <Typography
                                variant="h2"
                                sx={{
                                    lineHeight: isMedium
                                        ? '76.80px'
                                        : '100.80px',
                                    fontFamily: 'CabinetGrotesk-Variable',
                                    fontWeight: isMedium ? 700 : 800
                                    // fontSize: isMobile ? 40 : isMedium ? 64 : 84
                                }}
                                fontSize={isMedium ? 64 : 84}
                                color="primaryMuted.main"
                            >
                                Beyond{' '}
                                <Typography
                                    fontSize={isMedium ? 64 : 84}
                                    sx={{
                                        display: 'inline',
                                        color: 'primary.yellow',
                                        lineHeight: isMedium
                                            ? '76.80px'
                                            : '100.80px',
                                        fontFamily: 'CabinetGrotesk-Variable',
                                        fontWeight: isMedium ? 700 : 800
                                    }}
                                >
                                    Resume,
                                </Typography>
                            </Typography>
                            <Typography
                                mb={3}
                                variant="h2"
                                sx={{
                                    lineHeight: isMedium
                                        ? '76.80px'
                                        : '100.80px',
                                    fontFamily: 'CabinetGrotesk-Variable',
                                    fontWeight: 800,
                                    mb: '32px'
                                }}
                                color="primary.light"
                                fontSize={isMedium ? 64 : 84}
                            >
                                Beyond{' '}
                                <Typography
                                    fontSize={isMedium ? 64 : 84}
                                    sx={{
                                        display: 'inline',
                                        color: 'primary.yellow',
                                        lineHeight: isMedium
                                            ? '76.80px'
                                            : '100.80px',
                                        fontFamily: 'CabinetGrotesk-Variable',
                                        fontWeight: 800
                                    }}
                                >
                                    Keywords.
                                </Typography>
                            </Typography>
                            <Typography
                                mb={3}
                                variant="h2"
                                sx={{
                                    lineHeight: isMedium ? '36px' : '48px',
                                    fontFamily: 'Outfit',
                                    fontWeight: 400,
                                    mb: '32px'
                                }}
                                color="primary.light"
                                fontSize={isMedium ? 24 : 32}
                            >
                                Jobfactor: the ultimate talent-on-demand
                                marketplace powered by AI.
                            </Typography>
                            <a
                                rel="noopener noreferrer"
                                href="/create-account/company"
                            >
                                <Button
                                    sx={{
                                        // p: '4px',
                                        textTransform: 'none',
                                        width:
                                            isMobile || isMedium
                                                ? '100%'
                                                : '705px',
                                        height: '72px',
                                        borderRadius: '100px',
                                        border: `4px solid #FFFFFF`,
                                        textAlign: 'center',
                                        mb:
                                            isMedium || isMobile
                                                ? '48px'
                                                : '150px'
                                        // mt: '104px'
                                    }}
                                    variant="text"
                                >
                                    <Typography
                                        sx={{
                                            display: 'flex',
                                            // width: isMedium ? '100%' : '50%',
                                            fontSize: '24px',
                                            fontFamily: 'Outfit',
                                            fontWeight: '700',
                                            lineHeight: '28px',
                                            wordWrap: 'break-word',
                                            padding: '24px 0',
                                            textTransform: 'uppercase',
                                            color: '#FFFFFF',
                                            alignItems: 'center',
                                            '& svg': {
                                                marginLeft: '20px'
                                            },
                                            justifyContent: isMobile
                                                ? 'center'
                                                : undefined
                                        }}
                                    >
                                        Create Account
                                        <ArrowRightWhiteIconBold />
                                    </Typography>
                                </Button>
                            </a>
                        </Stack>
                        {/* Animated bubbles */}
                        <Stack
                            sx={{
                                width: isMobile ? '100%' : '50%',
                                mt: isMobile || isMedium ? '0px' : '-122px',
                                ml: isMobile || isMedium ? 0 : '5%',
                                position: 'relative',
                                maxWidth: isMobile ? '358px' : undefined,
                                mb: isMobile ? '130px' : '28px'
                            }}
                        >
                            <img
                                src={heroDots}
                                alt="several dots framing the images"
                                width={isMobile ? '97%' : undefined}
                            ></img>

                            <Slide
                                direction="down"
                                in={checked}
                                mountOnEnter
                                unmountOnExit
                                timeout={1500}
                                container={containerRef.current}
                                style={{
                                    position: 'absolute',
                                    top: isMobile ? '2%' : '-1.5%',
                                    left: isMobile ? '3%' : '2%',
                                    right: 0,
                                    bottom: 0,
                                    transitionDelay: '500ms'
                                }}
                            >
                                <Paper
                                    ref={containerRef}
                                    sx={imageStyles}
                                    elevation={0}
                                >
                                    <img
                                        src={HeroOval1}
                                        alt="Four Ovals stacked neatly overlapping featuring diverse professionals working"
                                        width={isMobile ? '50%' : undefined}
                                    ></img>
                                </Paper>
                            </Slide>
                            <Slide
                                direction="up"
                                in={checked}
                                mountOnEnter
                                unmountOnExit
                                timeout={1500}
                                container={containerRef.current}
                                style={{
                                    position: 'absolute',
                                    top: isMobile ? '2%' : '-1.5%',
                                    left: isMobile ? '37%' : '40%',
                                    right: 0,
                                    bottom: 0,
                                    transitionDelay: '500ms'
                                }}
                            >
                                <Paper
                                    ref={containerRef}
                                    sx={imageStyles}
                                    elevation={0}
                                >
                                    <img
                                        src={HeroOval2}
                                        alt="Four Ovals stacked neatly overlapping featuring diverse professionals working"
                                        width={isMobile ? '100%' : undefined}
                                    ></img>
                                </Paper>
                            </Slide>
                            <Slide
                                direction="left"
                                in={checked}
                                mountOnEnter
                                unmountOnExit
                                timeout={1500}
                                container={containerRef.current}
                                style={{
                                    position: 'absolute',
                                    top: isMobile ? '59%' : '42%',
                                    left: '-3%',
                                    right: 0,
                                    bottom: 200,
                                    transitionDelay: '500ms'
                                }}
                            >
                                <Paper
                                    ref={containerRef}
                                    sx={imageStyles}
                                    elevation={0}
                                >
                                    <img
                                        src={HeroOval3}
                                        alt="Four Ovals stacked neatly overlapping featuring diverse professionals working"
                                        width={isMobile ? '70%' : undefined}
                                    ></img>
                                </Paper>
                            </Slide>
                            <Slide
                                direction="right"
                                in={checked}
                                mountOnEnter
                                unmountOnExit
                                timeout={1500}
                                container={containerRef.current}
                                style={{
                                    position: 'absolute',
                                    top: isMobile ? '72%' : '55%',
                                    left: isMobile ? '11%' : '13%',
                                    right: 0,
                                    bottom: 200,
                                    transitionDelay: '500ms'
                                }}
                            >
                                <Paper
                                    ref={containerRef}
                                    sx={imageStyles}
                                    elevation={0}
                                >
                                    <img
                                        src={HeroOval4}
                                        alt="Four Ovals stacked neatly overlapping featuring diverse professionals working"
                                        width={isMobile ? '97%' : undefined}
                                    ></img>
                                </Paper>
                            </Slide>
                        </Stack>
                    </Stack>
                ) : (
                    //* Right side Animation *
                    <Stack
                        zIndex={3}
                        position="relative"
                        sx={{
                            width: isMobile ? '100%' : '50%',
                            display: 'flex',
                            flexDirection:
                                isMobile || isMedium ? 'column-reverse' : 'row',
                            alignItems:
                                isMobile || isMedium ? 'center' : undefined,
                            justifyContent:
                                isMobile || isMedium ? 'center' : 'center',
                            mx: isMobile ? '16px' : '60px',
                            mb: isMobile ? '110px' : 0,
                            gap: '48px'
                            // p: isMedium ? '16px' : 0
                        }}
                        // mt={isMobile ? undefined : '33px'}
                    >
                        {/* animated bubbles */}
                        <Stack
                            // p={isMedium ? '0px' : '40px'}
                            sx={{
                                // width: isMobile ? '100%' : '40%',
                                mt: isMobile || isMedium ? '0px' : '-122px',
                                ml: isMobile || isMedium ? 0 : '0%',
                                mr: isMobile || isMedium ? undefined : '3%',
                                pr: '',
                                position: 'relative',
                                maxWidth: isMobile ? '358px' : undefined
                            }}
                        >
                            <img
                                src={heroDots}
                                alt="several dots framing the images"
                                width={isMobile ? '97%' : undefined}
                            ></img>

                            <Slide
                                direction="down"
                                in={checked}
                                mountOnEnter
                                unmountOnExit
                                timeout={1500}
                                container={containerRef.current}
                                style={{
                                    position: 'absolute',
                                    top: '0%',
                                    left: '2%',
                                    right: 0,
                                    bottom: 0,
                                    transitionDelay: '500ms'
                                }}
                            >
                                <Paper
                                    ref={containerRef}
                                    sx={imageStyles}
                                    elevation={0}
                                >
                                    <img
                                        src={HeroOval5}
                                        alt="Oval featuring a woman brainstorming with sticky notes"
                                        width={isMobile ? '50%' : undefined}
                                    ></img>
                                </Paper>
                            </Slide>
                            <Slide
                                direction="up"
                                in={checked}
                                mountOnEnter
                                unmountOnExit
                                timeout={1500}
                                container={containerRef.current}
                                style={{
                                    position: 'absolute',
                                    top: isMobile ? '1%' : '0%',
                                    left: isMobile ? '35%' : '38%',
                                    right: 0,
                                    bottom: 0,
                                    transitionDelay: '500ms'
                                }}
                            >
                                <Paper
                                    ref={containerRef}
                                    sx={imageStyles}
                                    elevation={0}
                                >
                                    <img
                                        src={HeroOval6}
                                        alt="Oval featuring 4 diverse professionals holding each others wrists, making a square"
                                        width={isMobile ? '100%' : undefined}
                                    ></img>
                                </Paper>
                            </Slide>
                            <Slide
                                direction="left"
                                in={checked}
                                mountOnEnter
                                unmountOnExit
                                timeout={1500}
                                container={containerRef.current}
                                style={{
                                    position: 'absolute',
                                    top: isMobile ? '54%' : '41.5%',
                                    left: isMobile ? '0%' : '-10%',
                                    right: 0,
                                    bottom: 200,
                                    transitionDelay: '500ms'
                                }}
                            >
                                <Paper
                                    ref={containerRef}
                                    sx={imageStyles}
                                    elevation={0}
                                >
                                    <img
                                        src={HeroOval7}
                                        alt="Four Ovals stacked neatly overlapping featuring diverse professionals working"
                                        width={isMobile ? '80%' : undefined}
                                    ></img>
                                </Paper>
                            </Slide>
                            <Slide
                                direction="right"
                                in={checked}
                                mountOnEnter
                                unmountOnExit
                                timeout={1500}
                                container={containerRef.current}
                                style={{
                                    position: 'absolute',
                                    top: isMobile ? '70%' : '49%',
                                    left: isMobile ? '11%' : '12%',
                                    right: 0,
                                    bottom: 200,
                                    transitionDelay: '500ms'
                                }}
                            >
                                <Paper
                                    ref={containerRef}
                                    sx={imageStyles}
                                    elevation={0}
                                >
                                    <img
                                        src={HeroOval8}
                                        alt="Four Ovals stacked neatly overlapping featuring diverse professionals working"
                                        width={isMobile ? '100%' : undefined}
                                    ></img>
                                </Paper>
                            </Slide>
                        </Stack>

                        {/* Text / Button */}
                        <Stack
                            sx={
                                {
                                    // width: isMobile ? '100%' : '50%',
                                }
                            }
                        >
                            <Button
                                onClick={handleClick}
                                sx={{
                                    p: '4px',
                                    textTransform: 'none',
                                    fontSize: '20px',
                                    width: isMobile ? 'fit-content' : '372px',
                                    // maxWidth:
                                    //     isMobile || isMedium
                                    //         ? 'fit-co'
                                    //         : '705px',
                                    borderRadius: '100px',
                                    border: `4px solid ${
                                        toggleHero
                                            ? theme.palette.primary.main
                                            : 'primary.yellow'
                                    }`,
                                    mb: '32px',
                                    justifyContent: 'space-between'
                                }}
                                variant="text"
                            >
                                <Typography
                                    sx={{
                                        display: 'flex',
                                        fontSize: isMobile ? '14px' : '20px',
                                        fontFamily: 'Outfit',
                                        fontWeight: '700',
                                        lineHeight: '28px',
                                        wordWrap: 'break-word',
                                        color: toggleHero
                                            ? theme.palette.primary.main
                                            : 'primary.yellow',
                                        borderRadius: '100px',
                                        padding: '4px 8px',
                                        textTransform: 'uppercase',
                                        '& svg': {
                                            marginRight: '8px'
                                        },
                                        alignItems: 'center'
                                    }}
                                >
                                    <ArrowLeftIconBlue />
                                    Hire an employee
                                </Typography>
                                <Typography
                                    sx={{
                                        fontSize: isMobile ? '14px' : '20px',
                                        fontFamily: 'Outfit',
                                        fontWeight: '700',
                                        lineHeight: '28px',
                                        wordWrap: 'break-word',
                                        backgroundColor:
                                            theme.palette.primary.main,
                                        color: theme.palette.primary.light,
                                        borderRadius: '100px',
                                        padding: '4px 8px',
                                        textTransform: 'uppercase'
                                    }}
                                >
                                    Get Hired {}
                                </Typography>
                            </Button>
                            <Typography
                                variant="h2"
                                sx={{
                                    lineHeight: isMedium
                                        ? '76.80px'
                                        : '100.80px',
                                    fontFamily: 'CabinetGrotesk-Variable',
                                    fontWeight: 800
                                }}
                                color="#8C6B2A"
                                fontSize={isMedium ? 64 : 84}
                            >
                                Beyond{' '}
                                <span
                                    style={{
                                        color: toggleHero
                                            ? theme.palette.primary.main
                                            : 'primary.yellow'
                                    }}
                                >
                                    Resume,
                                </span>
                            </Typography>
                            <Typography
                                mb={3}
                                variant="h2"
                                sx={{
                                    lineHeight: isMedium
                                        ? '76.80px'
                                        : '100.80px',
                                    fontFamily: 'CabinetGrotesk-Variable',
                                    fontWeight: 800,
                                    mb: '32px'
                                }}
                                color="primary.light"
                                fontSize={isMedium ? 64 : 84}
                            >
                                Beyond{' '}
                                <span
                                    style={{
                                        color: toggleHero
                                            ? theme.palette.primary.main
                                            : 'primary.yellow'
                                    }}
                                >
                                    Keywords.
                                </span>
                            </Typography>

                            <Typography
                                mb={3}
                                variant="h2"
                                sx={{
                                    lineHeight: isMedium ? '36px' : '48px',
                                    fontFamily: 'Outfit',
                                    fontWeight: 400,
                                    mb: '32px'
                                }}
                                color="primaryDark.main"
                                fontSize={isMedium ? 24 : 32}
                            >
                                Jobfactor: the ultimate talent-on-demand
                                marketplace powered by AI.
                            </Typography>

                            <a
                                rel="noopener noreferrer"
                                href="/create-account/professional"
                            >
                                <Button
                                    sx={{
                                        textTransform: 'none',
                                        width:
                                            isMobile || isMedium
                                                ? '100%'
                                                : '705px',
                                        height: '72px',
                                        borderRadius: '100px',
                                        border: `4px solid #FFFFFF`,
                                        textAlign: 'center',
                                        backgroundColor: 'primary.main',
                                        mb:
                                            isMedium || isMobile
                                                ? '48px'
                                                : '150px'
                                    }}
                                    variant="text"
                                >
                                    <Typography
                                        sx={{
                                            width: isMobile
                                                ? '100%'
                                                : undefined,
                                            display: 'flex',
                                            fontSize: '24px',
                                            fontFamily: 'Outfit',
                                            fontWeight: '700',
                                            lineHeight: '28px',
                                            wordWrap: 'break-word',
                                            padding: '24px 0',
                                            textTransform: 'uppercase',
                                            color: '#FFFFFF',
                                            alignItems: 'center',
                                            '& svg': {
                                                marginLeft: '20px'
                                            },
                                            justifyContent: isMobile
                                                ? 'center'
                                                : undefined
                                        }}
                                    >
                                        Create Account
                                        <ArrowRightWhiteIconBold />
                                    </Typography>
                                </Button>
                            </a>
                        </Stack>
                    </Stack>
                )}

                {/*  */}
            </Container>
        </Container>
    );
};

export default HeroSection;
